<!-- THE SETUP (feature request section 4.1, S1-S11). The Kanban THE SETUP column is the
     definition; the sketch's Current Zone / Override Zone header is DROPPED — the footer zone
     indicator shows the zone and no override is offered (ruling Q4).
     Vertical collapsibles, never a wizard. The active section carries a distinct border. -->
<div class="maven-setup" data-element="maven-setup">

  <!-- EXPAND ALL / COLLAPSE ALL (owner vrequest 2026-09-15). A PINNED stripe above the scroll
       body — the Results column's "Sort by" stripe, by the owner's own pointing: same lift, same
       centred text, never scrolls away. ONE clickable text whose label flips; it moves every
       section and both Calls / Puts subsections at once, and never touches a side's checkbox.
       The label rule lives beside toggleAll() in the component. -->
  <div class="setup-toolbar" data-element="maven-setup-toolbar">
    <span class="toggle-all"
          [title]="this.toggleAllCollapses ? 'Collapse every section' : 'Expand every section'"
          data-element="maven-toggle-all"
          (click)="this.toggleAll()">{{ this.toggleAllLabel }}</span>
    <!-- THE RUN-DATA STRIPE (owner vrequest 2026-09-16, CR-20260916-004). Pinned with the text
         above it, never scrolls away: the saved positions and/or the saved hedge book the cards
         were priced on have changed since the run (shell settings echo, per-key snapshot at
         Apply — maven-run-data-watch.ts). One line, owner wording. Gone at Apply / Reset /
         portfolio change, and when the data returns to the run's state. -->
    <div class="run-data-changed"
         *ngIf="this.runDataSentence"
         data-element="maven-run-data-changed">{{ this.runDataSentence }}</div>
  </div>

  <!-- Everything above the action bar scrolls; the bar below does not. -->
  <div class="setup-body" data-element="maven-setup-body">
  <!-- DevExtreme's scroll view, NOT native overflow (owner ruling, 2026-09-11): nothing in this
       application scrolls natively, and the bare tag is the house form - 53 of the 72 usages in
       shared-components carry no attributes at all, with the sizing done on the parent. -->
  <dx-scroll-view>
  <!-- The scroll view's overlay scrollbar sits ON TOP of the content. This wrapper carries the
       right padding that keeps the content's right edge out from under it (vrequest 2026-09-13,
       item 1) — without it the spin buttons and chevrons at the edge were not clickable. -->
  <div class="setup-scroll-content">

  <!-- THE SUBSECTIONS ARE MAVEN'S OWN COLLAPSIBLES (vrequest 2026-09-13 #2, owner ruling: the
       DevExtreme accordion "turned out to be the wrong control for the job" — its dark theme
       painted the body black and sized the title to its text). Each one: a rounded hairline box,
       a full-width grey header with the label left and the chevron right, a body with NO fill of
       its own so the panel ground shows through. Several open at once; the whole header toggles.
       They must NOT look like the column-level bars (Setup / Results / Summary). -->
  <section class="sec"
           [class.sec--open]="this.isOpen('portfolio')"
           data-element="maven-sec-portfolio">
    <!-- .sec-head--changed (owner vrequest 2026-09-15): something inside no longer matches what the
         selected template or last run — the same yellow the field itself shows, carried up to the header
         so a collapsed section still says so. Same class on every section header below. -->
    <header class="sec-head"
            [class.sec-head--changed]="this.sectionChanged('portfolio')"
            (click)="this.toggleSection('portfolio')" data-element="maven-sec-head-portfolio">
      <span class="sec-title">Choose The Portfolio<span class="required" *ngIf="this.sectionRequired('portfolio')"
                                    data-element="maven-required-sec-portfolio">*</span></span>
      <span class="sec-chevron"
            [class.dx-icon-chevronup]="this.isOpen('portfolio')"
            [class.dx-icon-chevrondown]="!this.isOpen('portfolio')"></span>
    </header>

    <!-- THE BREADCRUMB CRADLE (owner vrequest 2026-09-15): while collapsed, chips saying what the
         section holds. The whole strip re-opens the section. No "Click to edit" (ruling). A chip
         whose field changed since the run is tinted yellow (.changed) — every cradle below too. -->
    <div class="crumbs" *ngIf="!this.isOpen('portfolio')"
         data-element="maven-crumbs-portfolio"
         (click)="this.toggleSection('portfolio')">
      <span class="chip" [class.changed]="this.chipChanged(c)" *ngFor="let c of this.portfolioCrumbs">{{ c.text }}</span>
    </div>

    <div class="sec-body" *ngIf="this.isOpen('portfolio')">
      <div class="field">
        <!-- A REQUIRED element carries a red asterisk beside its label until it is satisfied
             (vrequest 2026-09-13, item 3). The red sentence it replaces is gone for single-field
             requirements; backend refusals still render as sentences below. -->
        <label>Portfolio<span class="required" *ngIf="this.isRequired('portfolio')"
                              data-element="maven-required-portfolio">*</span></label>
        <!-- GROUPED, with a field template — the platform's own portfolio-picker shape.
             [grouped] renders each group's `key` as a header naming the owner. The field template
             is what makes the CLOSED box read "Alan K.  |  Default Portfolio": without it two
             different traders' default portfolios both read "Default Portfolio" and there is no
             way to tell which one is selected. Since CR-20260928-001 the default portfolio is a
             real portfolio flagged isDefault, never a synthetic entry. -->
        <dx-select-box [items]="this.portfolioGroups"
                       [grouped]="true"
                       [value]="this.selectedPortfolio"
                       displayExpr="name"
                       fieldTemplate="field"
                       [showClearButton]="true"
                       [disabled]="this.isRunning || this.templateBusy"
                       [class.param-changed]="this.isChanged('portfolio')"
                       placeholder="Choose a portfolio…"
                       data-element="maven-portfolio"
                       (onValueChanged)="this.onPortfolioChanged($event)">
          <div *dxTemplate="let data of 'field'">
            <dx-text-box [readOnly]="true"
                         [value]="data ? (data.userName + '  |  ' + data.name) : null"
                         placeholder="Choose a portfolio…"
                         data-element="maven-portfolio-field"></dx-text-box>
          </div>
        </dx-select-box>
      </div>

      <!-- S2 — ALWAYS VISIBLE, pre-filled from the APG's per-portfolio last-used template. Never
           silently applied: the trader sees which template will be used before he runs. -->
      <div class="field">
        <label>Adjustment Settings Template<span class="required" *ngIf="this.isRequired('template')"
                                        data-element="maven-required-template">*</span></label>
        <dx-select-box [items]="this.templates"
                       displayExpr="templateName"
                       valueExpr="templateId"
                       [value]="this.setup.templateId"
                       [showClearButton]="true"
                       [disabled]="this.isRunning || !this.selectedPortfolio"
                       [class.param-changed]="this.isChanged('template')"
                       placeholder="Choose a template…"
                       data-element="maven-template"
                       (onValueChanged)="this.onTemplateChanged($event)"></dx-select-box>
      </div>

      <!-- THE CURRENT ZONE (owner vrequest 2026-09-14, replacing ruling Q4's "the footer shows it").
           Read-only: the zone is what the footer indicator's pop-up set for this portfolio, read
           through GetPortfolioCurrentZoneData with the COMPOSITE key, and re-read on the footer's
           CurrentZoneChanged. No zone = red N/A and Apply blocked — Maven cannot run without one.
           There is NO Override Zone here, and there will not be (Q4's second half stands). The
           yellow border marks a zone that moved since the last run was sent: the cards on the
           right were priced for another one. -->
      <!-- THE PORTFOLIO ZONE (owner vrequest 2026-09-18) sits to the LEFT of the market zone
           since the owner's screencast of 2026-09-21 ("starting point, then ending point"),
           divided: "Portfolio Zone 6930 | 6910 Market Zone". It is the strike of the portfolio's
           near-dated short options (both when call and put differ), read from the saved APG
           positions — the shorts' orange; the market zone is off-white. N/A when there are no
           shorts or they expired. Display only: the run still sends ids. -->
      <div class="zone-line"
           [class.zone-line--stale]="this.zoneStale"
           data-element="maven-current-zone">
        <span class="zone-half zone-half--portfolio"
              title="The strike of the portfolio's short options (call / put when they differ). N/A: no shorts saved, or expired."
              data-element="maven-portfolio-zone">
          <span class="zone-word">Portfolio Zone</span>
          <span class="zone-value zone-value--portfolio"
                [class.zone-value--na]="!this.hasPortfolioZone"
                data-element="maven-portfolio-zone-value">{{ this.displayPortfolioZone }}</span>
        </span>
        <span class="zone-divider" aria-hidden="true"></span>
        <span class="zone-half zone-half--market"
              [title]="this.zoneStale ? 'The zone has changed since the last run. The results were priced for zone ' + this.lastRunZone + '.' : ''">
          <span class="zone-value zone-value--market"
                [class.zone-value--na]="!this.hasZone"
                data-element="maven-current-zone-value">{{ this.displayZone }}</span>
          <span class="zone-word">Market Zone</span>
        </span>
      </div>

      <p class="problem" *ngFor="let m of this.sentencesAt('portfolio')"
         data-element="maven-problem-portfolio">{{ m }}</p>
      <p class="problem" *ngFor="let m of this.sentencesAt('template')"
         data-element="maven-problem-template">{{ m }}</p>
    </div>
  </section>

  <section class="sec" [class.sec--open]="this.isOpen('settingsTemplate')"
           data-element="maven-sec-settingsTemplate">
    <header class="sec-head" [class.sec-head--changed]="this.templateDifferent"
            (click)="this.toggleSection('settingsTemplate')"
            data-element="maven-sec-head-settingsTemplate">
      <span class="sec-title">Maven Settings Template</span>
      <span class="sec-chevron" [class.dx-icon-chevronup]="this.isOpen('settingsTemplate')"
            [class.dx-icon-chevrondown]="!this.isOpen('settingsTemplate')"></span>
    </header>
    <div class="crumbs" *ngIf="!this.isOpen('settingsTemplate')"
         (click)="this.toggleSection('settingsTemplate')">
      <span class="chip" [class.changed]="this.templateDifferent">{{settingsTemplates.current?.label || 'No Template Selected'}}</span>
    </div>
    <div class="sec-body" [class.sec-body--hidden]="!this.isOpen('settingsTemplate')">
      <ets-maven-template-selector #settingsTemplates [underlying]="this.templateUnderlying" [disabled]="this.isRunning"
          [saveProblems]="this.templateSaveProblems"
          [different]="this.templateDifferent" (baselineChange)="this.onTemplateBaselineChanged($event)"
          [capture]="this.captureSettingsTemplate" (selected)="this.onSettingsTemplateSelected($event)"
          (busyChange)="this.onTemplateBusy($event)"></ets-maven-template-selector>
    </div>
  </section>

  <section class="sec"
           [class.sec--open]="this.isOpen('dates')"
           data-element="maven-sec-dates">
    <header class="sec-head"
            [class.sec-head--changed]="this.sectionChanged('dates')"
            (click)="this.toggleSection('dates')" data-element="maven-sec-head-dates">
      <span class="sec-title">Date Range<span class="required" *ngIf="this.sectionRequired('dates')"
                                    data-element="maven-required-sec-dates">*</span></span>
      <span class="sec-chevron"
            [class.dx-icon-chevronup]="this.isOpen('dates')"
            [class.dx-icon-chevrondown]="!this.isOpen('dates')"></span>
    </header>

    <!-- THE BREADCRUMB CRADLE (owner vrequest 2026-09-15): while collapsed, chips saying what the
         section holds. The whole strip re-opens the section. No "Click to edit" (ruling). -->
    <div class="crumbs" *ngIf="!this.isOpen('dates')"
         data-element="maven-crumbs-dates"
         (click)="this.toggleSection('dates')">
      <span class="chip" [class.changed]="this.chipChanged(c)" *ngFor="let c of this.datesCrumbs">{{ c.text }}</span>
    </div>

    <!-- KEPT ALIVE, ONLY HIDDEN while collapsed (owner vrequest 2026-09-15, "Date Range loses its
         inputs on collapse/expand"). The questionnaire below OWNS its inputs and starts empty on
         every creation, and its init emit then overwrote `setup.dates` with those empties. An
         *ngIf here re-created it on every expand, so every other section survived a fold (they are
         views over Setup-owned state) and this one did not. The hidden class keeps the one
         instance, and with it the trader's dates, weekday and specific-date exclusions. -->
    <div class="sec-body" [class.sec-body--hidden]="!this.isOpen('dates')">

      <!-- ONE TAG. The APG ORION's own questionnaire, exported for reuse by lane S2 on leader
           ruling L21 and hosted here unchanged. It delivers all of S3 and S10 in one place —
           single date or range, the Start anchored to the short-option expiration, a
           forward-only End, the cap message, Mondays out by default with a per-date un-exclude,
           the specific-date calendar, and the inert directional-bias placeholder.
           Reusing it rather than copying it is what makes Maven's date rules IDENTICAL to the
           APG's by construction instead of by intention.
           The "required" asterisk for the dates sits on the section TITLE, because this
           component is S2's and Maven does not edit its labels.
           `changedKeys` is the questionnaire's own order form: it paints its date, exclusion and
           bias cues from the keys it reads (date.kind, date.value, exclusions.weekdays,
           exclusions.dates, bias.*), and Maven's diff spells them exactly so. -->
      <ets-apg-roll-positions-panel
          [availableExpirations]="this.availableExpirations"
          [expirationsLoading]="this.expirationsLoading"
          [maxRangeDays]="this.maxRangeDays"
          [defaultWeekdayExclusions]="this.defaultWeekdayExclusions"
          [anchorKeyReader]="this.anchorKeyReader"
          [singleDateFollowsAnchor]="true"
          [rememberRangeExclusions]="true"
          [changedKeys]="this.changedKeys"
          data-element="maven-dates"
          (stateChange)="this.onDatesChanged($event)"></ets-apg-roll-positions-panel>

      <p class="problem" *ngFor="let m of this.sentencesAt('dates')"
         data-element="maven-problem-dates">{{ m }}</p>
    </div>
  </section>

  <section class="sec"
           [class.sec--open]="this.isOpen('existingHedges')"
           data-element="maven-sec-existingHedges">
    <header class="sec-head"
            [class.sec-head--changed]="this.sectionChanged('existingHedges')"
            (click)="this.toggleSection('existingHedges')" data-element="maven-sec-head-existingHedges">
      <span class="sec-title">Existing Hedges<span class="required" *ngIf="this.sectionRequired('existingHedges')"
                                    data-element="maven-required-sec-existingHedges">*</span></span>
      <span class="sec-chevron"
            [class.dx-icon-chevronup]="this.isOpen('existingHedges')"
            [class.dx-icon-chevrondown]="!this.isOpen('existingHedges')"></span>
    </header>

    <!-- THE BREADCRUMB CRADLE (owner vrequest 2026-09-15): while collapsed, chips saying what the
         section holds. The whole strip re-opens the section. No "Click to edit" (ruling). -->
    <div class="crumbs" *ngIf="!this.isOpen('existingHedges')"
         data-element="maven-crumbs-existingHedges"
         (click)="this.toggleSection('existingHedges')">
      <!-- CR-20260916-003: under Close, the plain chip is followed by one chip per side in the
           side's shade — `Calls · 16-Sep-26 (Hedge 1 · Hedge 2) · 19-Sep-26 (ALL)` (owner ruling 8). -->
      <span class="chip"
            *ngFor="let c of this.existingHedgesCrumbs"
            [class.chip--side]="!!c.side"
            [class.chip--calls]="c.side === 'calls'"
            [class.chip--puts]="c.side === 'puts'"
            [class.changed]="this.chipChanged(c)">{{ c.text }}</span>
    </div>

    <!-- HIDDEN, NOT DESTROYED, on a fold (CR-20260916-003, owner 2026-09-16 on the second build):
         the Close list below owns a live pricer and its ticker subscriptions; an *ngIf here would
         tear it down on every fold and rebuild it on the next open, with a re-read and a
         re-price the trader saw as a lag. Same mechanism as the Date Range body. -->
    <div class="sec-body" [class.sec-body--hidden]="!this.isOpen('existingHedges')">
      <!-- The ONLY action on existing hedges. There is no Adjust in iteration 1 (ruling E3), and
           this choice never touches the new-hedge parameters below, which are always asked. -->
      <dx-button-group [items]="this.existingHedgesButtons"
                       keyExpr="id"
                       selectionMode="single"
                       stylingMode="contained"
                       [disabled]="this.isRunning"
                       [class.param-changed]="this.isChanged('existingHedges')"
                       [selectedItemKeys]="this.existingHedgesKeys"
                       data-element="maven-existing-hedges"
                       (onItemClick)="this.onExistingHedgesClick($event)"></dx-button-group>
      <p class="note">Close prices the old hedges out and puts them in the package. Ignore leaves
        them where they are.</p>

      <!-- ⚠ UNDER IGNORE THE SAVED BOOK READ-OUT STAYS DELETED (G3, Alan): "he does not want the
           hedges shown, only the choice." Two buttons and nothing else.
           UNDER CLOSE (CR-20260916-003, owner screencast 2026-09-16) the choice became a
           SELECTION: the book's expirations as toggles and, per toggled expiration, its hedges
           with live close prices. The child is CREATED WITH THE SECTION and KEPT ALIVE across the
           Ignore / Close switch — hidden, not destroyed (owner, 2026-09-16, second build: a
           rebuild re-read the book and re-priced, which showed as a reset and a lag). Its model,
           its pricer and its ticker subscriptions live until the panel closes or the portfolio
           changes; under Ignore the selection is merely inert. -->
      <ets-maven-close-selection [class.close-selection--hidden]="this.setup.existingHedges !== 'close'"
                                 [portfolio]="this.selectedPortfolio"
                                 [selection]="this.setup.closeSelection"
                                 [disabled]="this.isRunning"
                                 [changedKeys]="this.changedKeys"
                                 (selectionChange)="this.onCloseSelectionChange($event)"
                                 (bookChange)="this.onCloseBookChange($event)"></ets-maven-close-selection>

      <p class="problem" *ngFor="let m of this.messagesAt('existingHedges')"
         data-element="maven-problem-existingHedges">{{ m }}</p>
    </div>
  </section>

  <section class="sec"
           [class.sec--open]="this.isOpen('hedgeParameters')"
           data-element="maven-sec-hedgeParameters">
    <header class="sec-head"
            [class.sec-head--changed]="this.sectionChanged('hedgeParameters')"
            (click)="this.toggleSection('hedgeParameters')" data-element="maven-sec-head-hedgeParameters">
      <span class="sec-title">Hedge Parameters<span class="required" *ngIf="this.sectionRequired('hedgeParameters')"
                                    data-element="maven-required-sec-hedgeParameters">*</span></span>
      <span class="sec-chevron"
            [class.dx-icon-chevronup]="this.isOpen('hedgeParameters')"
            [class.dx-icon-chevrondown]="!this.isOpen('hedgeParameters')"></span>
    </header>

    <!-- THE BREADCRUMB CRADLE (owner vrequest 2026-09-15): while collapsed, chips saying what the
         section holds. The whole strip re-opens the section. No "Click to edit" (ruling). -->
    <div class="crumbs" *ngIf="!this.isOpen('hedgeParameters')"
         data-element="maven-crumbs-hedgeParameters"
         (click)="this.toggleSection('hedgeParameters')">
      <!-- One BIG chip per side, in the side's own shade (owner, 2026-09-15). -->
      <span class="chip chip--side"
            *ngFor="let c of this.hedgeParametersCrumbs"
            [class.chip--calls]="c.side === 'calls'"
            [class.chip--puts]="c.side === 'puts'"
            [class.changed]="this.chipChanged(c)">{{ c.text }}</span>
    </div>

    <!-- Keep the side controls alive so folding the section preserves inactive risk choices. -->
    <div class="sec-body" [class.sec-body--hidden]="!this.isOpen('hedgeParameters')">

      <!-- One side may be left empty; both empty is refused (ruling Q7). -->
      <ets-maven-side-parameters side="calls"
                                 [inputs]="this.setup.calls" [presetApgSource]="this.presetApgSource"
                                 [defaultQty]="this.defaultQty"
                                 [targetInstrument]="this.targetInstrument"
                                 [strikeExpiration]="this.strikeExpiration"
                                 [expectedRangeAvailable]="this.expectedRangeAvailable"
                                 [disabled]="this.isRunning"
                                 [problems]="this.sideMessages('calls')"
                                 [changedKeys]="this.changedKeys"
                                 (changed)="this.onSideChanged()"></ets-maven-side-parameters>

      <ets-maven-side-parameters side="puts"
                                 [inputs]="this.setup.puts" [presetApgSource]="this.presetApgSource"
                                 [defaultQty]="this.defaultQty"
                                 [targetInstrument]="this.targetInstrument"
                                 [strikeExpiration]="this.strikeExpiration"
                                 [expectedRangeAvailable]="this.expectedRangeAvailable"
                                 [disabled]="this.isRunning"
                                 [problems]="this.sideMessages('puts')"
                                 [changedKeys]="this.changedKeys"
                                 (changed)="this.onSideChanged()"></ets-maven-side-parameters>

      <!-- The one composite requirement — at least one side — has no single element to star, so
           it stays a sentence. -->
      <p class="problem" *ngFor="let m of this.messagesAt('hedgeSides')"
         data-element="maven-problem-hedge-sides">{{ m }}</p>
    </div>
  </section>

  <!-- ============ Override Market Indicators (CR-20260915-001) ============ -->
  <!-- The ORION (OPG)'s Override Indicators block, hosted here unchanged (owner vrequest
       2026-09-15: "exactly this dialogue, exactly this section, exactly the same behaviour").
       AFTER Hedge Parameters and BEFORE Directional Bias, by the owner's own reasoning: the date
       range decides how many dates there are to override, the hedge parameters decide which
       sides run — so both come first. Duo (one fieldset per side) when both sides are enabled.
       The Setup owns the override map (setup.marketOverrides); the child is a view over it plus
       the live readings feed, and it is DESTROYED on collapse — which is also what stops its
       vertical-skew subscription, so a folded section streams nothing. -->
  <section class="sec"
           [class.sec--open]="this.isOpen('overrides')"
           data-element="maven-sec-overrides">
    <header class="sec-head"
            [class.sec-head--changed]="this.sectionChanged('overrides')"
            (click)="this.toggleSection('overrides')" data-element="maven-sec-head-overrides">
      <span class="sec-title">Override Market Indicators</span>
      <span class="sec-chevron"
            [class.dx-icon-chevronup]="this.isOpen('overrides')"
            [class.dx-icon-chevrondown]="!this.isOpen('overrides')"></span>
    </header>

    <!-- THE BREADCRUMB CRADLE: one chip per targeted date (values for an overridden date,
         "market" for an untouched one), or the single "All market" chip (owner ruling #2). -->
    <div class="crumbs" *ngIf="!this.isOpen('overrides')"
         data-element="maven-crumbs-overrides"
         (click)="this.toggleSection('overrides')">
      <span class="chip" [class.changed]="this.chipChanged(c)" *ngFor="let c of this.overridesCrumbs">{{ c.text }}</span>
    </div>

    <div class="sec-body" *ngIf="this.isOpen('overrides')">
      <ets-maven-override-indicators
          [dateKeys]="this.overrideDateKeys"
          [overrides]="this.setup.marketOverrides"
          [underlying]="this.underlying"
          [expirations]="this.expirationDescriptors"
          [callsEnabled]="this.callsEnabled"
          [putsEnabled]="this.putsEnabled"
          [disabled]="this.isRunning"
          [changedKeys]="this.changedKeys"
          data-element="maven-override-indicators"
          (allDatesOverrideChange)="this.onAllDatesOverride($event)"
          (overridesChange)="this.onOverridesChanged($event)"></ets-maven-override-indicators>

      <p class="problem" *ngFor="let m of this.messagesAt('marketOverrides')"
         data-element="maven-problem-overrides">{{ m }}</p>
    </div>
  </section>

  <!-- ============ S10 — Directional Bias ============ -->
  <!-- ITS OWN SECTION (owner, vrequest 2026-09-13 round 3: "it does not belong to the hedge
       parameters"), which REPLACES leader ruling L42's placement inside Hedge Parameters. Still
       visible and INERT in iteration 1: it reaches nothing on the wire (contract M1 section 8 has
       no field for it) and it gates nothing (ruling L47). The layout is the Max risk block's:
       the Yes/No pair stretched on one row, and when Yes, the directions on a row below with a
       plain gap — no vertical divider. -->
  <section class="sec"
           [class.sec--open]="this.isOpen('bias')"
           data-element="maven-sec-bias">
    <header class="sec-head"
            [class.sec-head--changed]="this.sectionChanged('bias')"
            (click)="this.toggleSection('bias')" data-element="maven-sec-head-bias">
      <span class="sec-title">Directional Bias</span>
      <span class="sec-chevron"
            [class.dx-icon-chevronup]="this.isOpen('bias')"
            [class.dx-icon-chevrondown]="!this.isOpen('bias')"></span>
    </header>

    <!-- THE BREADCRUMB CRADLE (owner vrequest 2026-09-15): while collapsed, chips saying what the
         section holds. The whole strip re-opens the section. No "Click to edit" (ruling). -->
    <div class="crumbs" *ngIf="!this.isOpen('bias')"
         data-element="maven-crumbs-bias"
         (click)="this.toggleSection('bias')">
      <span class="chip" [class.changed]="this.chipChanged(c)" *ngFor="let c of this.biasCrumbs">{{ c.text }}</span>
    </div>

    <div class="sec-body" *ngIf="this.isOpen('bias')">
      <div class="field bias" data-element="maven-bias">
        <dx-button-group [items]="this.biasEnabledButtons"
                         keyExpr="id"
                         selectionMode="single"
                         stylingMode="contained"
                         [disabled]="this.isRunning"
                         [class.param-changed]="this.isChanged('bias.enabled')"
                         [selectedItemKeys]="this.biasEnabledKeys"
                         data-element="maven-bias-enabled"
                         (onItemClick)="this.onBiasEnabledClick($event)"></dx-button-group>

        <dx-button-group *ngIf="this.biasEnabled"
                         [items]="this.biasDirectionButtons"
                         keyExpr="id"
                         selectionMode="single"
                         stylingMode="contained"
                         [disabled]="this.isRunning"
                         [class.param-changed]="this.isChanged('bias.direction')"
                         [selectedItemKeys]="this.biasDirectionKeys"
                         data-element="maven-bias-direction"
                         (onItemClick)="this.onBiasDirectionClick($event)"></dx-button-group>

        <p class="note">Direction buttons revealed only when Yes is selected · Auto runs its own sub-skill.</p>
      </div>
    </div>
  </section>

  </div><!-- /.setup-scroll-content -->
  </dx-scroll-view>
  </div><!-- /.setup-body -->

  <!-- ============ S11 — Apply ============ -->
  <!-- ⚠ There is NO STOP AND NO RESET-OF-A-RUNNING-RUN control here, and that is a ruling (R-D),
       not an omission: pressing Apply again is the only way a run in flight ends. Do not add one
       — there is no cancel command on the other end of it. -->
  <div class="apply-bar" data-element="maven-apply-bar">
    <div class="apply-buttons">
      <dx-button text="Run Maven"
                 type="default"
                 width="100%"
                 [disabled]="!this.canRun"
                 data-element="maven-apply"
                 (onClick)="this.onApply()"></dx-button>

      <!-- The ORION's own reset glyph (copilot-shared/opg-copilot.component.html uses
           icon="refresh" for the same gesture). Reset clears ALL THREE columns, not just this one
           (vrequest 2026-09-13, item 16). -->
      <dx-button text="Reset"
                 icon="refresh"
                 width="100%"
                 [disabled]="this.isRunning || this.templateBusy"
                 data-element="maven-reset"
                 (onClick)="this.onReset()"></dx-button>
    </div>

    <p class="problem" *ngFor="let m of this.messagesAt('applyBar')"
       data-element="maven-problem-apply">{{ m }}</p>
  </div>

</div>
